const mobileMenu = () => {
	// Hamburger menu
	const $hamburger = document.querySelector('.site-hamburger');

	$hamburger &&
	$hamburger.addEventListener('click', (e) => {
		document.body.classList.toggle('site-nav-open');

		$hamburger.setAttribute(
			'aria-expanded',
			$hamburger.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
		);
	});
};

export default mobileMenu;
